<template>
  <div>
    <div class="d-flex pt-5 pb-2 mb-3">
      <h2><span>Developers</span></h2>
    </div>

    <div class="col">
      <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-1 mt-4">
        <h4>API Keys</h4>
        <button title="Coming soon"  type="button" class="btn btn-sm btn-primary" @click="createToken"><icon name="plus-circle"></icon>&nbsp; Create API key</button>
      </div>
      <div class="table-responsive mt-4">
        <div v-if="loadingTokens">
          <icon name="settings" class="feather-spin"></icon>
        </div>
        <div v-else>
          <table class="table table-sm">
            <thead>
              <tr>
                <th>API KEY</th>
                <th>API</th>
                <th>CREATED</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(token,index) in tokens" :key="index">
                <td><span class="api-key">{{obfuscateToken(token)}}</span>
                  <span class="api-key-toggle ml-3" v-bind:class="{ 'api-key-toggle-hide': token.show }" @click="toggleTokenHide(token)">{{token.show? 'Hide' : 'Show'}}</span>
                  <span class="api-key-toggle ml-3" v-bind:class="{ 'api-key-toggle-hide': token.copied }" @click="copyToken(index)">{{token.copied? 'Copied' : 'Copy'}}</span>
                </td>
                <td><span class="badge badge-primary">Invoice protection</span></td>
                <td>{{formatDate(token.created)}}</td>
              </tr>
              <tr v-if="!tokens.length">
                <td colspan="2" class="pt-3 pb-2">You don't have any tokens yet</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="col mt-5">
      <h4 class="mb-1">Getting Started</h4>
        <p class="mt-4">Integrate insurance on your platform today</p>
        <p>
          <ul>
            <li>View the <a target="_blank" href="https://bnpl.docs.hokodo.co/">Hokodo BNPL API Documentation</a></li>
            <li>Contact us at <a target="_blank" href="mailto:tech@hokodo.co">tech@hokodo.co</a> if you have any questions.</li>
          </ul>
        </p>
    </div>
  </div>
</template>

<script>
import home from '../../api/home'
import moment from 'moment'

export default {
  data () {
    return {
      tokens: [],
      loadingTokens: true
    }
  },
  mounted () {
    home.getTokens(
      response => {
        this.tokens = response
        this.loadingTokens = false
      },
      error => {
        this.loadingTokens = false
        console.log('Token error', error)
      })
  },
  components: {

  },
  computed: {

  },
  methods: {
    formatDate: function (timestamp) {
      return moment(timestamp).local().format('YYYY-MM-DD HH:mm:ss')
    },
    toggleTokenHide: function (token) {
      if (token.show) {
        this.$set(token, 'show', false)
      } else {
        this.$set(token, 'show', true)
      }
    },
    obfuscateToken: function (token) {
      if (token.show) {
        return token.key
      } else { // Show only first 4 characters, hide the rest
        return token.key.slice(0, -36) + Array(37).join('*')
      }
    },
    createToken: function () {
      this.loadingTokens = true
      home.createToken(
        response => {
          home.getTokens(
            response => {
              this.tokens = response
              this.loadingTokens = false
            },
            error => {
              this.loadingTokens = false
              console.log('Token error', error)
            })
        },
        error => {
          console.log('Create token failed', error)
        })
    },
    copyToken: function (index) {
      var _this = this
      this.$copyText(this.tokens[index].key).then(function (e) {
        _this.$set(_this.tokens[index], 'copied', true)
        setTimeout(function () { _this.$set(_this.tokens[index], 'copied', false) }, 3000)
      }, function (e) {
        alert('Your browser does not currently support this function')
        console.log(e)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/Developer.vue